// ─────────────────────────────────────────────────────────────────────────────
// Replace all placeholder values with your actual AWS resource identifiers.
// Do NOT commit real credentials to source control — use environment variables
// or AWS Secrets Manager for production deployments.
// ─────────────────────────────────────────────────────────────────────────────

// ── Hosted UI / enterprise SSO (FMP-AU-001, FMP-AU-004) ──────────────────────
// The oauth block is what gives us the OIDC Authorization Code flow with PKCE
// (FMP-AU-001) and, on top of it, SAML federation to an enterprise IdP
// (FMP-AU-004). Amplify generates and verifies the PKCE code_verifier itself —
// never hand-roll that.
//
// It is declared ONLY when a Hosted UI domain is configured. Without a domain
// there is nothing to redirect to, and declaring oauth anyway would make
// signOut() attempt a redirect sign-out against a non-existent endpoint. So an
// unconfigured environment keeps exactly today's behaviour.
//
// The identity provider is deliberately not named here — REACT_APP_SSO_PROVIDER
// carries the Cognito IdP name (see src/lib/sso.js), so swapping the Google
// Workspace test IdP for the client's real one is a config change, not a code
// change.

// Cognito wants the domain as a bare host: no scheme, no trailing slash.
function normaliseDomain(value) {
  if (!value) return "";
  return value.replace(/^https?:\/\//, "").replace(/\/+$/, "");
}

// Amplify v6 takes redirect URLs as arrays, so a comma-separated env var lets a
// single build serve both localhost and the deployed origin.
function splitUrls(value) {
  if (!value) return [];
  return value.split(",").map((s) => s.trim()).filter(Boolean);
}

const cognitoDomain = normaliseDomain(process.env.REACT_APP_COGNITO_DOMAIN);
const redirectSignIn = splitUrls(process.env.REACT_APP_REDIRECT_SIGN_IN);
const redirectSignOut = splitUrls(process.env.REACT_APP_REDIRECT_SIGN_OUT);

const hostedUiConfigured =
  Boolean(cognitoDomain) && redirectSignIn.length > 0 && redirectSignOut.length > 0;

const awsExports = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
      ...(hostedUiConfigured
        ? {
            loginWith: {
              oauth: {
                domain: cognitoDomain,
                scopes: ["openid", "email", "profile"],
                redirectSignIn,
                redirectSignOut,
                // Authorization code + PKCE. "token" (implicit) would fail
                // FMP-AU-001 and put tokens in the URL fragment.
                responseType: "code",
              },
            },
          }
        : {}),
    },
  },
};

export const isHostedUiConfigured = hostedUiConfigured;

export default awsExports;
